import axios from 'axios'
import { CONFIG_URL, LOCAL_STORAGE, ERROR_CODES, TIME_OUT_API } from '../helpers/constants'
import moment from 'moment'
import { showMessageError } from '../helpers/functions'

const apiInstance = axios.create({
   baseURL: CONFIG_URL.SERVICE_URL,
   timeout: TIME_OUT_API,
   headers: { 'Content-Type': 'application/json' }
})

// Request Interceptor to add Authorization token
apiInstance.interceptors.request.use(
   async (config) => {
      const tokensString = await localStorage.getItem(LOCAL_STORAGE.DATA_AUTH)
      if (tokensString) {
         const tokens = JSON.parse(tokensString)
         const token = tokens?.tokens
         const tokenExpiresTime = tokens?.expiresIn
         const refreshToken = tokens?.refreshToken
         const refreshTokenExpiresTime = tokens?.refreshExpiresIn

         if (moment().isAfter(tokenExpiresTime)) {
            localStorage.removeItem(LOCAL_STORAGE.DATA_AUTH)
         } else if (moment().isAfter(refreshTokenExpiresTime)) {
            showMessageError('Phiên làm việc đã hết hạn. Vui lòng đăng nhập lại!')
            return Promise.reject('Token expired')
         } else {
            config.headers.Authorization = `Bearer ${token}`
         }
      }
      return config
   },
   (error) => Promise.reject(error)
)

// Response Interceptor to handle errors globally
apiInstance.interceptors.response.use(
   (response) => {
      if (response.data.code !== ERROR_CODES.SUCCESS) {
         showMessageError(response.data.message || '')
      }
      return response.data
   },
   (error) => {
      if (error?.message === 'Network Error') {
         showMessageError('Không có kết nối. Vui lòng thử lại')
      } else if (error?.message?.includes('timeout of')) {
         showMessageError('Hệ thống đang nâng cấp. Vui lòng thử lại sau')
      } else if (error.response?.data?.message === 'Error: Tài khoản cần được xác thực') {
         return { isAccountNotActive: true }
      } else {
         showMessageError(error.response?.data?.message)
      }
      return Promise.reject(error)
   }
)

export const uploadFile = (file, url) => {
   const formData = new FormData()
   formData.append('file', file)
   return apiInstance.post(url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
   })
}

export default apiInstance
